import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ShieldCheck, PenTool, Search, Layers, RefreshCw, Handshake, Plane, Bot, UserCheck, Flag } from "lucide-react";

const ICONS = [PenTool, ShieldCheck, Search, Layers, RefreshCw, Handshake, Plane, Bot, UserCheck, Flag];

export default function CharteEditorialePage() {
  const { t } = useTranslation();
  const P = t("pages.charte", { returnObjects: true });
  const sections = P.sections || [];

  return (
    <div className="min-h-screen bg-secondary pt-20" data-testid="charte-editoriale-page">
      <section className="bg-primary text-white py-16">
        <div className="max-w-3xl mx-auto px-6">
          <p className="font-accent text-accent text-lg italic mb-3">{P.kicker}</p>
          <h1 className="font-heading text-4xl md:text-5xl font-bold mb-4">{P.title}</h1>
          <p className="text-white/80 leading-relaxed">{P.intro}</p>
        </div>
      </section>

      <div className="max-w-3xl mx-auto px-6 py-12">
        <div className="bg-white border border-border rounded-lg p-6 md:p-8 mb-8">
          <h2 className="font-heading text-lg font-semibold text-primary mb-2">{P.boxH}</h2>
          <p className="text-muted-foreground leading-relaxed text-sm">{P.boxP}</p>
        </div>

        <div className="space-y-6">
          {sections.map((s, i) => {
            const Icon = ICONS[i] || PenTool;
            return (
              <section key={i} className="bg-white border border-border rounded-lg p-6" data-testid={`charte-section-${i + 1}`}>
                <div className="flex items-start gap-4">
                  <div className="w-10 h-10 rounded-lg bg-accent/10 flex items-center justify-center flex-shrink-0">
                    <Icon className="h-5 w-5 text-accent" />
                  </div>
                  <div>
                    <h2 className="font-heading text-lg font-semibold text-primary mb-2">{s.title}</h2>
                    <p className="text-muted-foreground leading-relaxed text-sm">{s.body}</p>
                  </div>
                </div>
              </section>
            );
          })}
        </div>

        <div className="mt-10 text-center">
          <Link to="/la-redaction" className="text-accent hover:text-accent/80 font-medium" data-testid="charte-to-redaction">
            {P.toRedaction}
          </Link>
        </div>
      </div>
    </div>
  );
}
